<app-pesquisa [(showDialog)]="pesquisarDialog" (pessoa)="loadData($event)"></app-pesquisa>

<app-relatorio-container
    tituloRelatorio="Declaração para Apresentação no Exterior"
    descricaoRelatorio="Declaração de aptidão para apresentação no exterior"
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'declaracao-exterior-medico.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6" [formGroup]="form">
            <p class="text-sm text-color-secondary m-0">
                A declaração é emitida para o médico selecionado. Instituição destinatária é obrigatória. O assinante é o usuário logado (escolha a UF em que assina); o nome do assinante é impresso no bloco de assinatura, no rodapé da declaração.
            </p>

            <app-card-medico-selecionado [pessoa]="pessoa()" [pessoaResponse]="pessoaResponse()" (alterar)="showPesquisarPessoa()"></app-card-medico-selecionado>

            <div class="field">
                <label class="font-semibold block mb-2">UF do Assinante</label>
                <app-estado-select [(uf)]="ufAssinante" (touched)="marcarUfAssinanteTocada()" (ufChange)="alterarUfAssinante($event)"></app-estado-select>
                @if (!ufAssinante && ufAssinanteTocada) {
                    <small class="p-error mt-2" style="color: red">Selecione a UF do assinante.</small>
                }
            </div>

            <div class="field">
                <label for="assinanteObj" class="font-semibold block mb-2">Assinante</label>
                <p-select
                    id="assinanteObj"
                    formControlName="assinanteObj"
                    [options]="assinantes()"
                    optionLabel="nmSolicitante"
                    placeholder="Selecione o assinante"
                    [filter]="false"
                    (onChange)="onAssinanteChange($event.value)"
                    [loading]="loadingAssinantes()"
                    styleClass="w-full"
                    appendTo="body"
                    emptyMessage="Nenhum registro encontrado para o seu CPF nesta UF"
                ></p-select>
                @if (form.get('assinanteObj')?.invalid && form.get('assinanteObj')?.touched) {
                    <small class="p-error mt-2" style="color: red">Selecione um assinante.</small>
                }
            </div>

            <div class="field">
                <label class="font-semibold block mb-2">UF Destino</label>
                <app-estado-select [(uf)]="ufDestino" [removeBR]="true" (touched)="marcarUfDestinoTocada()"></app-estado-select>
                @if (!ufDestino && ufDestinoTocada) {
                    <small class="p-error mt-2" style="color: red">Selecione a UF de destino.</small>
                }
            </div>

            <div class="field">
                <label for="instituicao" class="font-semibold block mb-2">Instituição destinatária</label>
                <input id="instituicao" type="text" pInputText formControlName="instituicao" class="w-full" placeholder="Instituição / órgão de destino" />
                @if (form.get('instituicao')?.invalid && form.get('instituicao')?.touched) {
                    <small class="p-error mt-2" style="color: red">Informe a instituição destinatária.</small>
                }
            </div>

            <div class="field">
                <label for="pais" class="font-semibold block mb-2">País (opcional)</label>
                <input id="pais" type="text" pInputText formControlName="pais" class="w-full" placeholder="País de destino" />
            </div>

            <div class="field">
                <label for="informacoesComplementares" class="font-semibold block mb-2">Informações complementares (opcional)</label>
                <textarea id="informacoesComplementares" pTextarea formControlName="informacoesComplementares" rows="3" class="w-full" placeholder="Texto adicional impresso ao final da declaração"></textarea>
            </div>

            <div class="field">
                <label for="numeroEtiqueta" class="font-semibold block mb-2">Número da etiqueta (opcional)</label>
                <input id="numeroEtiqueta" type="text" pInputText formControlName="numeroEtiqueta" class="w-full" placeholder="Número impresso no documento" />
            </div>

            <div class="field">
                <label for="txObservacao" class="font-semibold block mb-2">Observação (opcional)</label>
                <textarea id="txObservacao" pTextarea formControlName="txObservacao" rows="3" class="w-full" placeholder="Informe uma observação"></textarea>
            </div>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button
                    label="Gerar Declaração"
                    icon="pi pi-file-pdf"
                    [appCan]="roleGerar"
                    (click)="gerarRelatorio()"
                    [loading]="isPending"
                    [disabled]="isPending || form.invalid || !ufAssinante || !ufDestino || !possuiPessoaSelecionada"
                    pTooltip="Para gerar o relatório, selecione um médico."
                    tooltipPosition="top"
                    [tooltipDisabled]="possuiPessoaSelecionada"
                ></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
